var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileSandwhichMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#afa694;}.cls-2{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nav"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 36,
    height: 36,
    rx: 6.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 7.21,
    y1: 11,
    x2: 28.79,
    y2: 11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 7.21,
    y1: 18,
    x2: 28.79,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 7.21,
    y1: 25,
    x2: 28.79,
    y2: 25
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileSandwhichMenu);
export default __webpack_public_path__ + "static/media/MOBILE-sandwhich-menu.d1fa367f730ffa0c039576518993faf5.svg";
export { ForwardRef as ReactComponent };